export default "__VITE_ASSET__Cyf7NT7x__"